"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _elements = require("../../styles/elements");

var _util = require("../../util");

var _Dropdown = require("./Dropdown.styles");

var dropdownIcon = function dropdownIcon() {
  return /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;justify-content:center;position:absolute;right:0;top:0;bottom:0;transition:inherit;padding-right:", (0, _util.rem)(8), ";&>svg{transform:rotate(90deg);width:", (0, _util.rem)(20), ";height:", (0, _util.rem)(20), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:dropdownIcon;"));
};

var base = /*#__PURE__*/(0, _react.css)("min-width:", _Dropdown.dropdownWidth, ";display:flex;justify-content:space-between;&>*{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:", (0, _util.rem)(20), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));

var dropdownBtn = function dropdownBtn(theme) {
  return /*#__PURE__*/(0, _react.css)(_elements.button.styles.tertiary(theme), ";", base, ";&:hover{border-color:", theme.color.dropdownButton.borderHover, ";}&:active{background-color:", theme.color.monochrome.white, ";}&:focus{border-color:", theme.color.dropdownButton.borderFocus, ";}&:disabled{background-color:", theme.color.dropdownButton.backgroundDisabled, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:dropdownBtn;"));
};

var big = function big(theme) {
  return /*#__PURE__*/(0, _react.css)(_elements.text.styles.textSm(theme), ";color:", theme.color.buttonTertiary.text, ";padding-top:", (0, _util.rem)(8), ";padding-bottom:", (0, _util.rem)(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:big;"));
};

var small = /*#__PURE__*/(0, _react.css)("padding-top:", (0, _util.rem)(5), ";padding-bottom:", (0, _util.rem)(5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));

var textBtn = function textBtn(theme) {
  return /*#__PURE__*/(0, _react.css)("border:none;min-width:unset;padding:0;padding-right:", theme.spacing[5], ";background-color:transparent;&:hover{color:", theme.color.dropdown.textHover, ";background-color:transparent;}&:focus{color:", theme.color.dropdown.textFocus, ";}&:disabled{background-color:transparent;}" + (process.env.NODE_ENV === "production" ? "" : ";label:textBtn;"));
};

var prefix = function prefix(theme) {
  return /*#__PURE__*/(0, _react.css)("position:absolute;top:0;left:0;height:100%;width:", (0, _util.rem)(32), ";display:flex;align-items:center;justify-content:center;background-color:", theme.color.dropdownButton.prefixBg, ";color:", theme.color.dropdownButton.prefixText, ";svg{width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:prefix;"));
};

var withPrefix = /*#__PURE__*/(0, _react.css)("padding-left:", (0, _util.rem)(40), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:withPrefix;"));
var styles = {
  dropdownBtn: dropdownBtn,
  big: big,
  small: small,
  prefix: prefix,
  withPrefix: withPrefix,
  textBtn: textBtn,
  dropdownIcon: dropdownIcon
};
exports.styles = styles;
//# sourceMappingURL=DropdownButton.styles.js.map